"use strict"
import { getRequest, postRequest } from "@/services/RequestService";
import axios from "axios";

export const getWebinar = async () => {
  const base_route = `webinars`;
  const response = await getRequest(base_route);
  return response;
}

export const updateWebinar = async (request) => {
  const base_route = `webinars`;
  const response = await postRequest(base_route, request);
  return response;
}

export const getArchives = async () => {
  const base_route = `webinars/archives`;
  const response = await getRequest(base_route);
  return response;
}

export const viewArchive = async (id) => {
  const base_route = `webinars/archives/${id}/view`;
  const response = await getRequest(base_route);
  return response;
}

export const storeArchive = async (request) => {
  const base_route = `webinars/archives`;
  const response = await postRequest(base_route, request);
  return response;
}

export const updateArchive = async (request, id) => {
  const base_route = `webinars/archives/${id}/update`;
  const response = await postRequest(base_route, request);
  return response;
}

export const getCards = async () => {
  const base_route = `/cards`;
  const response = await getRequest(`${axios.lpsURL}${base_route}`);
  return response;
}
